import { Users, Gamepad2, Gauge } from "lucide-react";

const ITEMS = [
  { icon: Users, title: "Moniteurs expérimentés", desc: "Chaque élève est accompagné par un mentor dédié pendant toute sa formation, avec déblocage progressif des cours.", color: "#00a86b" },
  { icon: Gauge, title: "Simulateur nouvelle génération", desc: "Maîtrisez les situations complexes en toute sécurité avant de prendre la route. Une première en Île-de-France.", color: "#FF8C42" },
  { icon: Gamepad2, title: "E-Learning interactif", desc: "36 cours structurés, quiz à 3 niveaux de difficulté progressive et suivi pédagogique en temps réel.", color: "#00a86b" },
];

export default function Atouts() {
  return (
    <section id="atouts" className="anchor-offset py-24 md:py-32 bg-white" data-testid="atouts-section">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-[#00a86b] font-headings font-bold text-sm uppercase tracking-[0.2em]">Pourquoi DDSBillancourt</div>
          <h2 className="mt-3 font-headings font-black text-4xl md:text-5xl text-[#1a2332] tracking-tight">
            L'excellence pédagogique rencontre la technologie.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <div key={it.title} className="bg-[#f8faff] rounded-2xl p-6 border border-black/5 lift hover:shadow-md hover:border-[#00a86b]/20">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${it.color}15`, color: it.color }}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="mt-6 font-headings font-bold text-lg text-[#1a2332]">{it.title}</h3>
                <p className="mt-2 text-sm text-[#5b6577] leading-relaxed">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
